import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'estimer-temps-transit',
  templateUrl: './estimer-temps-transit.component.html',
  styleUrls: ['./estimer-temps-transit.component.scss']
})
export class EstimerTempsTransitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
